import { ExternalUrlListItem, ExternalUrlsSearchModel } from './types-store';

export const ACTION = {
  CLEAR_LIST: 'EXTERNAL_URLS_ADMINISTRATION:CLEAR_LIST',

  REQUEST_LIST: 'EXTERNAL_URLS_ADMINISTRATION:REQUEST_LIST',
  RECEIVE_LIST: 'EXTERNAL_URLS_ADMINISTRATION:RECEIVE_LIST',
  FAIL_LIST: 'EXTERNAL_URLS_ADMINISTRATION:FAIL_LIST',

  REQUEST_DELETE_EXTERNAL_URL: 'EXTERNAL_URLS_ADMINISTRATION:REQUEST_DELETE_EXTERNAL_URL',
  RECEIVE_DELETE_EXTERNAL_URL: 'EXTERNAL_URLS_ADMINISTRATION:RECEIVE_DELETE_EXTERNAL_URL',
  FAIL_DELETE_EXTERNAL_URL: 'EXTERNAL_URLS_ADMINISTRATION:FAIL_DELETE_EXTERNAL_URL'
};

export class ClearList {
  public type: string = ACTION.CLEAR_LIST;
  constructor(public requestId: number) { }
}

export class RequestList {
  public type: string = ACTION.REQUEST_LIST;
  constructor(public requestId: number, public model: ExternalUrlsSearchModel, public clearResults: boolean) { }
}

export class ReceiveList {
  public type: string = ACTION.RECEIVE_LIST;
  constructor(public requestId: number, public list: ExternalUrlListItem[], public numberOfResults: number) { }
}

export class FailList {
  public type: string = ACTION.FAIL_LIST;
  constructor(public requestId: number) { }
}

export class RequestDeleteExternalUrl {
  public type: string = ACTION.REQUEST_DELETE_EXTERNAL_URL;
  constructor(public id: number) { }
}

export class ReceiveDeleteExternalUrl {
  public type: string = ACTION.RECEIVE_DELETE_EXTERNAL_URL;
  constructor(public id: number) { }
}

export class FailDeleteExternalUrl {
  public type: string = ACTION.FAIL_DELETE_EXTERNAL_URL;
  constructor(public id: number) { }
}
